(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/deposit-limits-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/deposit-limits-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiterHelper;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('accountservices-react:deposit-limits');
  jupiterHelper = trinidad.components.require('tb-utils', 'jupiter-helper').jupiterHelper;
} else {
  jupiterHelper = svs.components.tbUtils.jupiterHelper;
  logger = svs.accountservicesReact.deposit.depositLimits.logger;
}
const getDepositLimitsAsync = async req => {
  const options = {
    method: 'GET',
    path: "/player/2/depositlimits",
    req
  };
  logger.info('Getting deposit limits');
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  if (error) {
    logger.info('Error getting deposit limits', error);
  }
  return {
    data: {
      limits: data === null || data === void 0 ? void 0 : data.limits,
      limitsIsSet: data === null || data === void 0 ? void 0 : data.limitsIsSet
    },
    error
  };
};
const getMaxLimitsAsync = async req => {
  var _data$response;
  const options = {
    method: 'GET',
    path: '/gamblingcare/1/spendlimit/info',
    req
  };
  logger.info("Getting max}");
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  if (error) {
    logger.info('Error getting max limits', error);
  }
  return (_data$response = data === null || data === void 0 ? void 0 : data.response) !== null && _data$response !== void 0 ? _data$response : {};
};
const exportedMethods = {
  getDepositLimitsAsync,
  getMaxLimitsAsync
};
if (isServer) {
  module.exports = exportedMethods;
} else {
  svs.accountservicesReact.deposit.depositLimitsService = exportedMethods;
}

 })(window);